/**
 * Example JavaScript singleton module
 */

var Links = (function($) {
  function initFooterSmoothScroll() {
    var sectionMap = {
      home: "body",
      services: ".home-services",
      about: ".home-about"
    };

    $(document).on("click", ".footer-menu__link[data-link]", function(e) {
      var linkKey = $(this).data("link");
      var targetSelector = sectionMap[linkKey];
      var $target = $(targetSelector);

      if (!$target.length) {
        return;
      }

      e.preventDefault();

      var headerHeight = $(".header").outerHeight() || 0;
      var targetPosition;

      if (linkKey === "home") {
        targetPosition = 0;
      } else {
        targetPosition = $target.offset().top - headerHeight;
      }

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: targetPosition
          },
          1000
        );
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".footer").length) {
      return;
    }

    initFooterSmoothScroll();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Links.init);
